import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-slate-200 bg-white">
        <div className="max-w-5xl mx-auto px-4 py-4 flex items-center gap-3">
          <Link to="/" className="flex items-center gap-3" data-testid="terms-brand-link">
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-white shadow-sm ring-1 ring-slate-200">
              <img src="/logo.png" alt="DocMania logo" className="h-8 w-8 object-contain" />
            </div>
            <span className="text-xl font-extrabold tracking-tight text-slate-900">
              <span className="text-blue-600">Doc</span>
              <span className="text-orange-500">Mania</span>
            </span>
          </Link>
        </div>
      </header>

      <div className="max-w-3xl mx-auto px-4 py-12">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground mb-8">
          <ArrowLeft className="h-4 w-4" /> Back to Home
        </Link>
        <h1 className="text-3xl font-bold text-foreground mb-2" data-testid="terms-title">Terms &amp; Conditions</h1>
        <p className="text-sm text-muted-foreground mb-8">Last updated: {new Date().toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}</p>

        <div className="prose prose-sm text-foreground/90 space-y-6">
          <section>
            <h2 className="text-lg font-semibold">1. Acceptance of Terms</h2>
            <p>By accessing or using DocMania, you agree to be bound by these Terms &amp; Conditions. If you do not agree, do not use the service.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold">2. Service Description</h2>
            <p>DocMania provides document generation and processing services, including but not limited to: business proposals, grant proposals, resumes and cover letters, invoices, purchase orders, waybills, delivery notes, quotations, PDF compression, and visa/passport photo generation. Services are provided on a credit-based system; credits do not expire.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold">3. Credits &amp; Billing</h2>
            <p>Credits are purchased in advance and consumed when you use services. Each service action consumes a fixed number of credits as displayed before use. Credits are non-refundable except where required by law. Failed operations will return credits to your balance automatically.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold">4. AI-Assisted Content</h2>
            <p>Some documents generated through DocMania are created with the assistance of AI-powered tools. You are responsible for reviewing all generated content for accuracy, completeness, and suitability before relying on it or submitting it to any third party, including lenders, grant bodies, employers, or business partners. DocMania does not guarantee the accuracy of AI-assisted content.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold">5. Acceptable Use</h2>
            <p>You agree not to: upload illegal, harmful, or infringing content; attempt to circumvent security or billing controls; use automated tools to abuse the service; or share your account credentials.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold">6. Intellectual Property</h2>
            <p>You retain ownership of all files you upload and documents you generate. DocMania retains no rights to your content. The DocMania service, brand, and technology remain our intellectual property.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold">7. Account Suspension &amp; Termination</h2>
            <p>We reserve the right to suspend or terminate accounts that violate these Terms, engage in fraudulent activity, or abuse the service, at our discretion and without prior notice.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold">8. Limitation of Liability</h2>
            <p>DocMania is provided &quot;as is.&quot; We are not liable for any indirect, incidental, or consequential damages, including damages arising from reliance on AI-assisted content. Our total liability is limited to the amount of credits purchased in the preceding 12 months.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold">9. Modifications</h2>
            <p>We may update these terms at any time. Continued use of the service after changes constitutes acceptance of the new terms.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold">10. Contact</h2>
            <p>Questions about these terms? Contact us at <strong>support@docmania.co</strong>.</p>
          </section>
        </div>
      </div>
    </div>
  );
}
